import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigEntityService } from '../../../../core/services/config-entity.service';
import { FileImage } from '../../../../core/models/fileImage';

@Component({
  selector: 'app-add-new-image',
  templateUrl: './add-new-image.component.html',
  styleUrls: ['./add-new-image.component.scss']
})
export class AddNewImageComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<AddNewImageComponent>,
    private configEntityService: ConfigEntityService,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { name: string, updateForm: boolean, imageDetail: FileImage }
  ) { }

  fileImageForm: FormGroup;
  isUpdateForm = this.data.updateForm;
  imageName = this.data.name;
  updateImageDetail = this.data.imageDetail;

  ngOnInit(): void {
    if (this.isUpdateForm) {
      this.buildUpdateForm(this.updateImageDetail)
    }
    else {
      this.buildNewImageForm();
    }
  }

  buildUpdateForm(updateImageDetail: FileImage) {
    this.fileImageForm = this.formBuilder.group({
      name: [updateImageDetail.name, Validators.required],
      infrastructure: [updateImageDetail.infrastructure],
      friendlyName: [updateImageDetail.friendlyName],
      path: [updateImageDetail.path],
      size: [updateImageDetail.size],
      format: [updateImageDetail.format],
      platform: [updateImageDetail.platform],
      description: [updateImageDetail.description]
    });
  }

  buildNewImageForm() {
    this.fileImageForm = this.formBuilder.group({
      name: ['', Validators.required],
      infrastructure: [''],
      friendlyName: [''],
      path: [''],
      size: [''],
      format: [''],
      platform: [''],
      description: ['']
    });
  }

  submitForm() {
    if (this.isUpdateForm) {
      if (this.fileImageForm.valid) {
        const formData: FileImage = {
          name: this.fileImageForm.value.name,
          infrastructure: this.fileImageForm.value.infrastructure,
          friendlyName: this.fileImageForm.value.friendlyName,
          path: this.fileImageForm.value.path,
          size: this.fileImageForm.value.size,
          format: this.fileImageForm.value.format,
          platform: this.fileImageForm.value.platform,
          description: this.fileImageForm.value.description,
          createdOn: "",
          lastUpdatedOn: ""
        };
        this.configEntityService.updateImageDetails(formData, this.updateImageDetail.friendlyName).subscribe({
          next: (data) => {
            this.dialog.close(data)
          },
          error: (err) => {
            this.dialog.close(err.error)
          }
        })
      }
    } else {
      if (this.fileImageForm.valid) {
        const formData: FileImage = {
          name: this.fileImageForm.value.name,
          infrastructure: this.fileImageForm.value.infrastructure,
          friendlyName: this.fileImageForm.value.friendlyName,
          path: this.fileImageForm.value.path,
          size: this.fileImageForm.value.size,
          format: this.fileImageForm.value.format,
          platform: this.fileImageForm.value.platform,
          description: this.fileImageForm.value.description,
          createdOn: "",
          lastUpdatedOn: ""
        };
        this.configEntityService.addNewImageDetails(formData).subscribe({
          next: (data) => {
            this.dialog.close(data)
          },
          error: (err) => {
            this.dialog.close(err.error)
          }
        })
      }
    }
  }

  onClose() {
    this.dialog.close(null);
  }

}
